import React, {useEffect, useState} from 'react';
import {Card} from 'uikit/components';
import styles from './BuildingLoadingPlaceCard.module.styl'
import {arrayOf, number, shape, string, func, bool} from 'prop-types';
import {getDatesFromDateRange, getShortTime, toShortDateStringLocale} from 'utils';
import {Days} from 'utils/days';
import {percentageLevels} from 'utils/indicator/indicatorSettings';
import cx from 'classnames';
import LoadingCalendar from '../../calendar/loadingCalendar/LoadingCalendar';

export default function BuildingLoadingPlaceCard({placeData, index, startDate, endDate, onClick, showToggle, showCameraDetectionData}){

    const [dates, setDates] = useState(null);

    const indicatorStyle = percentageLevels.indicatorColorWithOverload(placeData.loadingPercent ?? 0);

    useEffect(() => {
        let daysOfWeek = Days.GetAllDays();
        let data = [];
        let dates = getDatesFromDateRange(startDate, endDate);
        dates.forEach((x, index) => {

            let isWorkingDay = placeData.workingDays.length !== 0
                && placeData.workingDays
                    .map(item => item.day)
                    .includes(daysOfWeek[index].Id);

            let placeDataItem = isWorkingDay ? placeData.workingDays
                .find(item => item.day === daysOfWeek[index].Id) : null;

            let dataItem = {
                dateShortName: toShortDateStringLocale(x),
                date: x,
                dayOfWeek: daysOfWeek[index].ShortName,
                isWorkingDay: isWorkingDay,
                startTime: placeDataItem !== null ? placeDataItem.startTime : null,
                endTime: placeDataItem !== null ? placeDataItem.endTime : null,
                participantsCount: placeDataItem !== null ? placeDataItem.participantsCount : 0,
                loading: placeDataItem !== null ? placeDataItem.loading : 0,
            }
            data.push(dataItem);
        });
        setDates(data);
    }, [endDate, placeData, startDate]);

    return (
        <Card borderRadius={'giant'} padding={'none'} className={styles.card}>
            <div data-test-name="building_loading_place_card">
                <div className={styles.header}>{index}. {placeData.name}</div>
                <div className={styles.placeInfo}>
                    <div className={styles.placeInfoHeader}>Единовременная пропускная способность: <div className={styles.highlightValue}>{placeData.throughput}</div></div>
                    <div className={styles.placeInfoHeader}>Общее число посетителей: <div className={styles.highlightValue}>{placeData.participantsCount ?? 0}</div></div>
                    <div className={styles.placeInfoHeader}>Общая загрузка: <div className={cx(styles.highlightValue, indicatorStyle.textStyle)}>{placeData.loadingPercent ?? 0}%</div></div>
                </div>
                <div className={styles.container} data-test-name="building_loading_place_week">
                    {dates !== null && dates.map((x, index) => (
                        <div key={index}>
                            <div className={styles.itemHeader}>
                                <div className={cx(styles.date, !x.isWorkingDay && styles.red )}>{x.dateShortName} {x.dayOfWeek.toUpperCase()}</div>
                                <div className={cx(styles.time, !x.isWorkingDay && styles.red)}>{x.isWorkingDay ? `${getShortTime(x.startTime) ?? ''} - ${getShortTime(x.endTime) ?? ''}` : `${'Выходной'}`}</div>
                            </div>
                            <div className={styles.itemBody}>
                                <div className={styles.itemBodyHeader}>Посетителей:
                                    <div className={styles.itemBodyValue}>{x.participantsCount}</div>
                                </div>
                                <div className={styles.itemBodyHeader}>Загрузка:
                                    <div className={cx(styles.itemBodyLoadingValue, percentageLevels.indicatorColorWithOverload(x.loading ?? 0).textStyle)}>{x.loading ?? 0}%</div>
                                </div>
                            </div>
                        </div>
                      )
                )}
                </div>
                {showToggle && placeData.workingDays !== null && placeData.workingDays.length !== 0 && (
                        <LoadingCalendar
                            showCameraDetectionData={showCameraDetectionData}
                            workingDays={placeData.workingDays}
                            dates={dates.map(item => ({
                                date: item.date,
                                dayOfWeek: item.dayOfWeek,
                                participantsCount: item.participantsCount,
                                loading: item.loading,
                                isWorkingDay: item.isWorkingDay,
                            }))}
                        />
                  )}
                {placeData.workingDays !== null && placeData.workingDays.length !== 0 &&
                        <div onClick={() => onClick(showToggle ? null : index - 1)} className={styles.toggleLink} data-test-name="btn_show_schedule">
                            {!showToggle ? 'Показать расписание' : 'Скрыть расписание'}
                        </div>
                }
            </div>
        </Card>
    )
}

BuildingLoadingPlaceCard.propTypes = {
    placeData: shape({
            id: number.isRequired,
            name: string.isRequired,
            throughput: number.isRequired,
            workingDays: arrayOf(shape({
                day: string,
                date: string,
                startTime: string,
                endTime: string,
                loading: number,
                participantsCount: number,
                trainingData: arrayOf(shape({
                    trainingId: number,
                    endTime: string,
                    groupCode: string,
                    loadingPercent: number,
                    participantsCount: number,
                    schoolName: string,
                    sportTrainingLevel: string,
                    sportTypeName: string,
                    sportsmanCount: number,
                    startTime: string,
                    coachName: string,
                    schoolId: number,
                }))
            })).isRequired,
            loadingPercent: number,
            participantsCount: number
        }),
    index: number.isRequired,
    startDate: string.isRequired,
    endDate: string.isRequired,
    onClick: func.isRequired,
    showToggle: bool.isRequired,
    showCameraDetectionData: bool.isRequired,
}